﻿(function () {
    "use strict";

    angular
        .module("app")
        .component("fabButton", {
            bindings: {
                href: "@",
                target: "@?",
                icon: "@"
            },
            templateUrl: ['version', function (version) {
                return `/js/components/fabButton/fab-button.html?v=${version}`
            }],
            transclude: true
        });
})();